import React from 'react';
// Modules
import {
  Button, Heading, SimpleGrid, Text, VStack,
} from '@chakra-ui/react';
import Link from 'next/link';
// Components
import GiftIcon from '../icon/GiftIcon';
import TagIcon from '../icon/TagIcon';
import UserGroupIcon from '../icon/UserGroupIcon';
// Contexts
import { useAuth } from '../../contexts/AuthContext';
// Utils
import routes from '../../utils/routes';

const MemberBenefits: React.FC = () => {
  const { currentUser, isLoading } = useAuth();

  if (currentUser || isLoading) return null;

  return (
    <VStack alignItems="stretch" bgColor="#FEF7E4" borderRadius="md" p="8" spacing="8">
      <Heading as="h2" size="md" textAlign="center">
        Keuntungan menjadi member Utama Stationery
      </Heading>
      <SimpleGrid columns={[1, 3]} spacing="8">
        <VStack>
          <UserGroupIcon fill="blackAlpha.700" height="64px" mb="2" width="64px" />
          <Heading as="h3" size="sm" textAlign="center">
            Kemudahan Pengumpulan Poin
          </Heading>
          <Text textAlign="center">Kumpulkan poin secara otomatis setiap berbelanja.</Text>
        </VStack>
        <VStack>
          <TagIcon fill="blackAlpha.700" height="64px" mb="2" width="64px" />
          <Heading as="h3" size="sm" textAlign="center">
            Promo Menarik
          </Heading>
          <Text textAlign="center">Dapatkan informasi promo terbaru secara cepat.</Text>
        </VStack>
        <VStack>
          <GiftIcon fill="blackAlpha.700" height="64px" mb="2" width="64px" />
          <Heading as="h3" size="sm" textAlign="center">
            Tukar Hadiah
          </Heading>
          <Text textAlign="center">Tukarkan poin dengan berbagai hadiah menarik.</Text>
        </VStack>
      </SimpleGrid>
      <Link href={routes.signUp.href} passHref>
        <Button alignSelf="center" as="a" colorScheme="primary" textColor="black">
          Daftar Sekarang
        </Button>
      </Link>
    </VStack>
  );
};

export default MemberBenefits;
